
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import AddService from './components/AddService/AddService';
import Dashboard from './components/Dashboard/Dashboard';
import Login from './components/Login/Login';
import AuthProvider from './context/AuthProvider/AuthProvider';
import SecureRoute from './SecureRoute/SecureRoute';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Login></Login>}></Route>
          <Route path='/dashboard' element={<SecureRoute><Dashboard /></SecureRoute>}></Route>
          <Route path='/add-service' element={<SecureRoute><AddService /></SecureRoute>}></Route>
          <Route path='*' element={<Login></Login>}></Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
